import React from "react";
import { FormattedMessage } from "react-intl";

import AppProvider from "2g-app-provider";
import { Logos } from "2g-icons";
import { createUseLogserverJWTProvider } from "2g-fetch-provider";

import "../less/index.less";
import configureStore from "b2b/store/configureStore";
import App from "b2b/App";
import { BASE } from "b2b/api";
import { PATHS } from "b2b/constants";
import messages from "b2b/i18n";
import LoginForm from "b2b/components/LoginForm";
import paths from "b2b/router";
import { useUserInfo } from "b2b/hooks";
import CookiesContent from "b2b/components/cookies-content/CookiesContent";

const initialState = {};

console.log("B2B Portal - start"); //eslint-disable-line

const onError = () => {};
const store = configureStore(initialState);
const useAuthProvider = createUseLogserverJWTProvider({
  urlLogin: BASE.login(),
  urlSuccess: PATHS.BASE
});
export const AppContainer = () => (
  <AppProvider
    cookies={{ content: CookiesContent }}
    window
    redux={{ store }}
    intl={{ messages, onError }}
    router={{ paths }}
    modules
    fetch={{
      useAuthProvider: useAuthProvider
    }}
    auth={{
      useUserInfo,
      loginForm: <LoginForm />,
      appLogo: <Logos.VUZLogo />,
      appName: (
        <FormattedMessage
          id="b2b.navigation.title"
          defaultMessage="B2B Portál"
        />
      )
    }}
    notifications
    dialogs
  >
    <App />
  </AppProvider>
);
